import { useMutation, useQueryClient } from 'libs/query'
import { useNavigate } from 'libs/router'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useTranslation } from 'libs/i18n'
import { apiRoutes } from 'config/apiRoutes'
import { routes } from 'config/routes'
import { queryKeys } from 'config/queryKeys'

export const useCreateAreaType = () => {
	const { t } = useTranslation()
	const queryClient = useQueryClient()
	const navigate = useNavigate()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: createAreaType, isPending: isCreateAreaTypeLoading } = useMutation({
		mutationFn: (data: FormData) => {
			return axiosPrivate.post(apiRoutes.areaTypes(), data, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.boothTypes.all })
			useToast({ type: 'success', message: t('Area type created') })()

			navigate(routes.areaTypeIndex)
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		createAreaType,
		isCreateAreaTypeLoading
	}
}
